/**
 * RepeatIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const RepeatIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M22.998 11.997h-2a9 9 0 0 0-13.8-7.61 1 1 0 0 0-.26 1.48 1 1 0 0 0 1.34.21 6.86 6.86 0 0 1 3.72-1.08 7 7 0 0 1 7 7h-2a.5.5 0 0 0-.39.81l3 3.7a.5.5 0 0 0 .78 0l3-3.7a.5.5 0 0 0-.39-.81m-7.28 5.92a6.86 6.86 0 0 1-3.72 1.08 7 7 0 0 1-7-7h2a.5.5 0 0 0 .39-.81l-3-3.7a.5.5 0 0 0-.78 0l-3 3.7a.5.5 0 0 0 .39.81h2a9 9 0 0 0 13.8 7.61 1 1 0 0 0 .26-1.48 1 1 0 0 0-1.34-.21" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const RepeatIcon = makeIcon('RepeatIcon', RepeatIconSvg)
